<style scoped>
 span.top-app-title {
   font-weight: bold;
   font-size: 1.5em;
   /*font-family: monospace;*/
   font-family: 'Roboto';
 }
 span.top-app-title.manufacturer-name {
   font-size: 1.8em;
   margin-right: 10px;
   color: #e6010a;
 }
 span.top-app-title.model-name {
   /*color: rgba(127,80,114);*/
   color: #424242;
 }
 div.title-top-left-margin {
   padding: 40px
 }
 div.lds-ripple-area {
   margin-bottom: 0px;
 }
 div.lds-ripple-loading-text {
   color: #666;
 }
</style>
<!-- https://vuetifyjs.com/ja/components/dialogs/#scrollable -->
<!-- https://vuetifyjs.com/ja/components/bottom-sheets/ -->
<!-- https://vuetifyjs.com/ja/components/dialogs/#section-30cd30b930c8 -->
<template>
  <v-app>
    <v-overlay :value="loadingSplashShow" color="white" opacity="1" z-index="300">
      <div class="lds-ripple-area justify-align-center">
        <div class="lds-ripple"><div></div><div></div></div>
      </div>
      <div class="lds-ripple-loading-text justify-align-center">
        Loading ...
      </div>
      <div class="lds-ripple-loading-text justify-align-center">
        AKAI EWI 4000s Editor β
      </div>
    </v-overlay>
    <!-- -->
    <v-app-bar app :color="app_var_background_color" min-width="{appBarMinWidth}" class="">
      <div class="d-flex justify-align-center title-top-left-margin">
        <!--span class="top-app-title manufacturer-name"><v-img contain width="60" src="images/akai-professional-1.svg"></v-img></span-->
        <span class="top-app-title manufacturer-name"><v-img contain width="100" src="images/akai_pro_logo.png"></v-img></span>
        <span class="top-app-title model-name">EWI 4000s Editor β</span>
      </div>

      <v-spacer></v-spacer>
      <!--
      <v-btn
          target="_blank"
          @click="openDeviceCommunicationApp()"
          text
      >
        <v-icon>{{ icons.midi }}</v-icon>
        &nbsp;
        <span class="mr-2">Patch List</span>
      </v-btn>
      -->
    </v-app-bar>

    <v-main>
      <router-view ref="router"/>
    </v-main>

    <br>

    <v-footer absolute padless dark>
      <v-card
          class="flex"
          flat
          tile
      >
        <v-card-text class="py-2 white--text text-center">
          EWI4000s Editor (c) {{ new Date().getFullYear() }} <strong>Ryoya Kawai</strong>
        </v-card-text>
      </v-card>
    </v-footer>

  </v-app>
</template>

<script>
 import { mdiMidiPort } from '@mdi/js'

 export default {
   name: 'App',

   components: {},

   computed: {
     loadingSplashShow: {
       get: function() {
         return this.$store.getters.getLoadingSplashShow()
       },
       set: function() {}
     }
   },

   methods: {
     sendOnePatchApp: async function(encodedPatch=null, onmidimessage=()=> {}, mode='store') {
       if (encodedPatch==null) {
         return
       }
       console.log(encodedPatch, onmidimessage, mode)
       await this.$refs.router.$refs.MidiDeviceControls.sendOnePatch(encodedPatch, onmidimessage, mode)
     },
     encodeOnePatchApp: function(editPatch_decoded) {
       return this.$refs.router.$refs.MidiDeviceControls.encodeOnePatch(editPatch_decoded)
     },
     sendArrayChannelMessageApp: function(arr_message=[]) {
       this.$refs.router.$refs.MidiDeviceControls.sendArrayChannelMessage(arr_message)
     },
     openDeviceCommunicationApp: function() {
       this.$refs.router.$refs.MidiDeviceControls.handleDeviceCommunicationDialog(true)
     },
     repaintPanelApp: function(name=null) {
       if (name==null) return
       this.$router.app.$children[0].$refs.router.repaintPanel.bind(this)(name)
     },
     repaintAllPanelApp: function() {
       this.$router.app.$children[0].$refs.router.repaintAllPanel.bind(this)()
     },
     showOnePatchOnUiApp: async function(patchNo=null, closeDialog=true, closePanels=true) {
       console.log(`[Fired] showOnePatchOnUiApp() patchNo=[${patchNo}]`)
       this.$refs.router.$refs.MidiDeviceControls.showOnePatchOnUi.bind(this)(patchNo, closeDialog, closePanels)
       // set all param and repaint all of components
       await this.$router.app.$children[0].$refs.router.applyParamToUi.bind(this)(patchNo)

       // repaint all component
       this.repaintAllPanelApp()
     },
     // let PatchNumNameCard component to recognise params change
     updateParamIsSyncedApp: function() {
       console.log('[Fired] updateParamIsSyncedApp()')
       //this.$refs.router.$refs.PatchNumNameCard.updateParamIsSynced()
       this.$refs.router.$refs.PatchAction.updateParamIsSynced()
     },
     switchDemoDevicePatchesApp: function(loadDemoApp=true) {
       this.$router.app.$children[0].$refs.router.switchDemoDevicePatches(loadDemoApp)
     },
     syncParamEditOnePatchToDeviceApp: function() {
       console.log('[Fired] syncParamEditOnePatchToDeviceApp()')
       //this.$refs.router.$refs.MidiDeviceControls.syncParamEditOnePatchToDevice()
       this.$refs.router.$refs.MidiDeviceControls.openSyncParamEditOnePatchToDeviceDialog()
     },
     discardParamEditOnePatchApp: function() {
       console.log('[Fired] discardParamEditOnePatchApp()')
       //this.$refs.router.$refs.MidiDeviceControls.discardParamEditOnePatch.bind(this)()
       //this.$refs.router.$refs.PatchAction.updateParamIsSynced.bind(this)()
       this.$refs.router.$refs.MidiDeviceControls.discardParamEditOnePatch()
       this.$refs.router.$refs.PatchAction.updateParamIsSynced()
     }
   },

   created: function() {
     const onScreensizeChanged = () => {
       const fixed_content_width = this.$data.appBarMinWidth // min-width of <v-app-bar>
       const window_size = document.body.getBoundingClientRect()
       const window_size_width = window_size.width
       const viewport_scale = (Math.round(10000 * window_size_width/fixed_content_width) / 10000)
       if (viewport_scale<1) {
         document.querySelector("meta[name='viewport']").setAttribute('content', `width=device-width,initial-scale=${viewport_scale},user-scalable=no`)
       }
     }
     window.onresize = function(){
       //onScreensizeChanged()
     }
     window.onorientationchange = () => {
       onScreensizeChanged()
     }
     // initialize
     onScreensizeChanged()
   },

   mounted: function() {
   },

   data: () => ({
     icons: {
       midi: mdiMidiPort
     },
     //app_var_background_color: 'rgb(245,232,207)'
     app_var_background_color: 'rgb(219,203,199)',
     appBarMinWidth: 905
   }),
};
</script>
